export default {
	pub: {
		httpHeader: {},
		defaultLoadingMessage: undefined,
	},
}
